import React, { useState, useEffect } from "react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTableFijo from "../useTableFijo";
import moment from "moment";

const headCells = [
  {
    id: "1",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: (
      <i style={{ textAlign: "center" }} className="fas fa-qrcode">
        {" "}
        N° DE FACTURA
      </i>
    ),
    textAlign: "center",
  },
  {
    id: "2",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: (
      <i style={{ textAlign: "center" }} className="fas fa-calendar-week">
        {" "}
        FECHA/EMISIÓN
      </i>
    ),
    textAlign: "center",
  },
  {
    id: "3",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: (
      <i style={{ textAlign: "center" }} className="fas fa-pen-alt">
        {" "}
        DESCRIPCIÓN
      </i>
    ),
    textAlign: "center",
  },
  {
    id: "4",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: (
      <i style={{ textAlign: "center" }} className="fas fa-check-square">
        {" "}
        ESTATUS
      </i>
    ),
    textAlign: "center",
  },
];

const TablaRelacionFacturasproc = (props) => {
  const [records, setRecords] = useState([]);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableFijo(records, headCells, filterFn, 280);

  useEffect(() => {
    if (props.factura) {
      setRecords(props.factura);
    }
  }, [props.factura]);

  return (
    <div className="card">
      <div className="card-body">
        <div className="content">
          <div className="container">
            <div className="row" style={{ margin: 0 }}>
              <div className="col-md-12" style={{ margin: "auto" }}>
                <TblContainer>
                  <TblHead />

                  <TableBody>
                    {records &&
                      records.map((item, index) => (
                        <TableRow
                          key={item.anio + item.mes}
                          style={{ padding: "0" }}
                        >
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {item.numfactura}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {moment(item.fechaemision).format("DD/MM/YYYY")}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {item.descripcion}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {item.status}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </TblContainer>
                <TblPagination />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TablaRelacionFacturasproc;



// WEBPACK FOOTER //
// ./src/components/impuestoprodu/tablaRelacionFacturas.js